import React, { useState } from "react";
import { HiArrowLongRight, HiArrowLongLeft } from "react-icons/hi2";

const FAQSection = () => {
  // State to keep track of the currently active question
  const [activeQuestion, setActiveQuestion] = useState(null);

  // Questions and answers
  const faqs = [
    {
      id: 1,
      question: "How can I make a reservation?",
      answer:
        "You can make a reservation by visiting our website or calling our customer support team. ",
    },
    // {
    //   id: 2,
    //   question: "Can I purchase gift cards for food?",
    //   answer:
    //     "Yes, gift cards are available for purchase on our website. They make great gifts for family and friends!",
    // },
    {
      id: 3,
      question: "What are the payment methods?",
      answer:
        "We accept all major credit and debit cards, as well as digital wallets like Apple Pay and Google Pay.",
    },
  ];

  // Function to toggle the active question
  const toggleQuestion = (id) => {
    setActiveQuestion(activeQuestion === id ? null : id);
  };

  return (
    <div className="flex flex-col sm:flex-row gap-6 mt-[6rem]">
      {/* Left Section */}
      <div className="flex-[1.3] flex flex-col">
        {faqs.map((faq) => (
          <div
            key={faq.id}
            className={`border border-[#321D1D] rounded mt-5 ${
              activeQuestion === faq.id ? "flex flex-col" : ""
            }`}
          >
            <div
              className="flex justify-between items-center p-8 cursor-pointer"
              onClick={() => toggleQuestion(faq.id)}
            >
              <div className="body font-medium text-[36px] leading-[42px]">
                {faq.question}
              </div>
              {activeQuestion === faq.id ? (
                <HiArrowLongLeft
                  className="text-[#AF313D]"
                  style={{ width: "50px", height: "50px" }}
                />
              ) : (
                <HiArrowLongRight
                  className="text-[#AF313D]"
                  style={{ width: "50px", height: "50px" }}
                />
              )}
            </div>
            {activeQuestion === faq.id && (
              <p className="p-4 text-[#321D1D] body text-[20px] leading-[30px]">
                {faq.answer}
              </p>
            )}
          </div>
        ))}
      </div>

      {/* Right Section */}
      <div className="mt-28 flex-1 flex flex-col gap-8 items-end text-right">
        <h2 className="text-[16px] body text-[#A46C32] leading-[24px] tracking-[3PX]">
          FAQ
        </h2>

        <p className="mt-4 body font-bold text-[40px] leading-[64px]">
          "Find answers to your most common questions quickly and easily."
        </p>

        
      </div>
    </div>
  );
};

export default FAQSection;
